/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InlineResponse20014Data model module.
 * @module model/InlineResponse20014Data
 * @version 1.0.0
 */
class InlineResponse20014Data {
    /**
     * Constructs a new <code>InlineResponse20014Data</code>.
     * @alias module:model/InlineResponse20014Data
     */
    constructor() { 
        
        InlineResponse20014Data.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InlineResponse20014Data</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineResponse20014Data} obj Optional instance to populate.
     * @return {module:model/InlineResponse20014Data} The populated <code>InlineResponse20014Data</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineResponse20014Data();

            if (data.hasOwnProperty('cart_id')) {
                obj['cart_id'] = ApiClient.convertToType(data['cart_id'], 'String');
            }
            if (data.hasOwnProperty('cart_url')) {
                obj['cart_url'] = ApiClient.convertToType(data['cart_url'], 'String');
            }
            if (data.hasOwnProperty('refresh')) {
                obj['refresh'] = ApiClient.convertToType(data['refresh'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * @member {String} cart_id
 */
InlineResponse20014Data.prototype['cart_id'] = undefined;

/**
 * @member {String} cart_url
 */
InlineResponse20014Data.prototype['cart_url'] = undefined;

/**
 * @member {Boolean} refresh
 */
InlineResponse20014Data.prototype['refresh'] = undefined;






export default InlineResponse20014Data;

